import beneficiaryLookupService from '@/services/beneficiary-lookup.service.js'
import * as arcService from '@/services/arc-api.service';
import * as medicalCatalogService from '@/services/medical-catalogs.service';
import * as plansService from '@/services/plans-api.service';
import * as dispensingService from '@/services/dispensing-api.service.js';
import * as providerService from '@/services/providers-api.service.js';
import * as fingerPrintService from '@/services/finger-print.service.js';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { sanitizeEndpointError } from '@/utils'
import { v4 as uuidv4 } from 'uuid';
import router from '@/router'
import vuei18n from '@/plugins/vue-i18n';
import {
    NEW_AUTHORIZATION_SET_TYPE,
    NEW_AUTHORIZATION_SET_SPONSOR,
    NEW_AUTHORIZATION_SET_SPONSOR_FORM,
    NEW_AUTHORIZATION_ERROR,
    SET_SPONSOR_SEARCH_METHOD,
    SET_INPUTS_SPONSOR_SEARCH_VALUES,
    AUTHORIZATIONS_ERROR,
    AUTHORIZATIONS_SUCCESS,
    AUTHORIZATONS_LOADING,
    BENEFICIARIES_SUCCESS,
    SET_BENEFICIARY_SELECTED,
    SET_BENEFICIARY_SELECTION,
    COMPLETE_TYPE_STEP,
    COMPLETE_SPONSOR_STEP,
    COMPLETE_METHOD_STEP,
    COMPLETE_BENEFICIARY_STEP,
    COMPLETE_BENEFICIARY_SEARCH,
    SET_BENEFICIARY,
    FIND_BENEFIRIARY_ERROR,
    SET_AUTHORIZATION_FORM_VALUES,
    SET_BIOMETRIC_VERIFICATION_RESULT,
    SET_LOADING_VERIFICATION,
    SET_LOADING_CREATE_CLAIM,
    SET_CREATE_CLAIM_ERROR,
    SET_NAVBAR_TYPE,
    CLEAR_NEW_AUTHORIZATION,
    SET_CREATE_CLAIM_RESULT,
    AUTHORIZATION_DETAIL_SUCCESS,
    AUTHORIZATION_DETAIL_HEADER,
    CLEAR_AUTHORIZATION_DETAIL,
    DIALOG_AUTHORIZATION_FILES_ATTACH,
    AUTHORIZATION_DETAIL_FILE,
    AUTHORIZATION_CREATION_BACK_STEP,
    AUTHORIZATION_CREATION_NEXT_STEP,
    SET_PRESCRIPTION,
    PRESCRIPTION_CREATED,
    CLEAR_PRESCRIPTION,
    SET_SPONSOR_PRODUCTS,
    SET_SPONSOR_PRODUCT_DETAIL,
    DISPENSING_LOADING,
    DISPENSING_ERROR,
    SET_DISPENSING_COSHARINGS,
    DISPENSATION_CREATION_LOADING,
    SET_COMPLETED_DISPENSATION,
    CLEAR_DISPENSATION,
    SET_SPONSORS,
    SET_PROVIDER_PRODUCT_TYPES,
    SET_BIOMETRIC_VERIFICATION_REQUIRED,
    RESET_BIOMETRIC_VALIDATION,
    SET_SPONSOR_DOCUMENT_POLICY,
    SET_PROVIDER_INFORMATION,
    SET_BIOMETRIC_VERIFICATION_METHOD,
    SET_SPONSOR_ENABLE_UPDATE_DATA,
    SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS,
    SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR
} from './types';

const cancelNewAuthorization = ({commit}) =>{
    commit(CLEAR_NEW_AUTHORIZATION)
}

const cleanNewAuthorizationSteps = ({dispatch}) =>{
    dispatch('completeSponsorStep', false)
    dispatch('completeMethodStep', false)
    dispatch('completeBeneficiaryStep', false)
    dispatch('completeBeneficiarySearch', false)
}

const completeAuthorizationTypeStep = ({ commit }, payload) => {
    commit(COMPLETE_TYPE_STEP, payload)
}

const completeSponsorStep = ({ commit }, payload) => {
    commit(COMPLETE_SPONSOR_STEP, payload)
}

const completeMethodStep = ({ commit }, payload) => {
    commit(COMPLETE_METHOD_STEP, payload)
}

const completeBeneficiaryStep = ({ commit }, payload) => {
    commit(COMPLETE_BENEFICIARY_STEP, payload)
}

const completeBeneficiarySearch = ({commit}, payload) => {
    commit(COMPLETE_BENEFICIARY_SEARCH, payload)
}

const setAuthorizationType = ({ commit }, payload) => {
    commit(NEW_AUTHORIZATION_SET_TYPE, payload)
}

const setAuthorizationSponsor = ({commit}, payload) => {
    commit(NEW_AUTHORIZATION_SET_SPONSOR, payload)
}

const getSponsorForm = async ({ commit }, payload) => {
    try{
        const response = await beneficiaryLookupService.getSponsorForm(payload);
        const data = camelizeKeys(response.data)
        commit(NEW_AUTHORIZATION_SET_SPONSOR_FORM, data)
    } catch (error) {
        commit(NEW_AUTHORIZATION_ERROR, error)
    }
}

const setSponsorSearchMethod = ({ commit }, payload) => {
    commit(SET_SPONSOR_SEARCH_METHOD, payload)
}

const setInputSponsorSearchValues = ({ commit }, payload) => {
    commit(SET_INPUTS_SPONSOR_SEARCH_VALUES, payload)
}

const getBeneficiaries = async ({ commit, state, rootState }) => {
    commit(AUTHORIZATONS_LOADING, true)
    commit(AUTHORIZATIONS_ERROR, false)
    commit(COMPLETE_BENEFICIARY_SEARCH, false)
    commit(BENEFICIARIES_SUCCESS, {})
    try{
        const requestValues = state.newAuthorization.beneficiarySearch;
        const providerSlug = rootState.auth.tokenExtensions.providerSlug;

        const request = decamelizeKeys({ 
            formSlug: requestValues.formSlug,
            providerSlug, 
            inputs: requestValues.inputs
        });

        const payload = {
            request: request,
            sponsorSlug: requestValues.sponsorSlug
        };

        const response = await beneficiaryLookupService.getBeneficiaries(payload)
        let data = camelizeKeys(response)

        if(data.status === 202){            
            if(data.headers.location){

                let monitor = await beneficiaryLookupService.getBeneficiaryMonitor(data.headers.location)                
                if(monitor.data.status === 'ERROR'){
                    throw monitor.data
                }
                
                commit(BENEFICIARIES_SUCCESS, camelizeKeys(monitor.data))
                commit(AUTHORIZATONS_LOADING, false)    
                commit(COMPLETE_BENEFICIARY_SEARCH, true)

            }
            else{
                throw data
            }

        }else if(data.status === 200){
            commit(BENEFICIARIES_SUCCESS, camelizeKeys(response.data))
            commit(AUTHORIZATONS_LOADING, false)    
            commit(COMPLETE_BENEFICIARY_SEARCH, true)
        }else{
            throw 'The search beneficiary response status is unknown'
        }
        
    }catch(error){
        commit(AUTHORIZATIONS_ERROR, true)
        commit(AUTHORIZATONS_LOADING, false)
        commit(COMPLETE_BENEFICIARY_SEARCH, true)       
    }
}

const setBeneficiarySuccess = ({commit}, payload) =>{
    commit(BENEFICIARIES_SUCCESS, payload)
}

const setBeneficiarySelected = ({ commit }, payload) => {
    commit(SET_BENEFICIARY_SELECTED, payload)
}

const setBeneficiarySelection = ({ commit }, payload) => {
    commit(SET_BENEFICIARY_SELECTION, payload)
}

const getAuthorizations = async ({ commit, rootGetters }, filters) => {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    commit(AUTHORIZATONS_LOADING, true)
    try {
        const response = await arcService.getAuthorizations(providerSlug, filters);
        commit(AUTHORIZATIONS_SUCCESS, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    } catch (error) {
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    }      
};

const getSponsorConfiguration = async ({ commit, state }) => {
    const sponsorSlug = state.newAuthorization.beneficiarySearch.sponsorSlug;
    commit(AUTHORIZATONS_LOADING, true)
    try {
        const response = await arcService.getSponsorConfiguration(sponsorSlug);
        const configurations = camelizeKeys(response.data)
        commit(SET_SPONSOR_ENABLE_UPDATE_DATA, configurations.allowBeneficiaryDataUpdate)
        commit(AUTHORIZATONS_LOADING, false)
    } catch (error) {
        commit(SET_SPONSOR_ENABLE_UPDATE_DATA, false)
        commit(AUTHORIZATONS_LOADING, false)
    }      
};

const getBeneficiary = async ({ commit, state }) => {
    const beneficiarySelectedId = state.beneficiarySelected.id || '';

    try {
        const response = await plansService.getBeneficiary(beneficiarySelectedId)
        commit(SET_BENEFICIARY, camelizeKeys(response.data))
        commit(FIND_BENEFIRIARY_ERROR, false)
    } catch (error) {
        commit(FIND_BENEFIRIARY_ERROR, true)
    }
}

const updateBeneficiary = async ({ commit, state }, payload) => {
    const beneficiarySelectedId = state.beneficiarySelected.id || '';
    commit(AUTHORIZATONS_LOADING, true)
    try {
        const response = await plansService.updateBeneficiary(beneficiarySelectedId, payload)
        const isUpdateData = (response.status === 200)
        commit(AUTHORIZATONS_LOADING, false)
        return isUpdateData
    } catch (error) {
        commit(AUTHORIZATONS_LOADING, false)
        return false
    }
}

const setAuthorizationFormValues = ({ commit }, payload) => {
    commit(SET_AUTHORIZATION_FORM_VALUES, payload)
}

const setNavBarType = ({commit}, payload) => {
    commit(SET_NAVBAR_TYPE, payload)
}

const verifyBiometric = async ({ commit, state, rootState }, payload) => {
    commit (SET_LOADING_VERIFICATION, true)
    commit(SET_BIOMETRIC_VERIFICATION_RESULT, null)
    const beneficiarySelectedId = state.beneficiarySelected.id || '';
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;

    const body = {
        beneficiaryId: beneficiarySelectedId,
        type: payload.type,
        value: payload.value
    }

    try {
        const response = await arcService.sendBiometricValidation(providerSlug, body)
        const result = camelizeKeys(response.data)
        commit(SET_BIOMETRIC_VERIFICATION_RESULT, result)
        commit (SET_LOADING_VERIFICATION, false)
    } catch (error) {
        commit(SET_BIOMETRIC_VERIFICATION_RESULT, { verificationStatus: 'ERROR' })
        commit (SET_LOADING_VERIFICATION, false)
    }
}

const biometricValidationBypass = ({ commit }) => {
    const payloadSuccess = {data: {verificationStatus: "VERIFICATION_SUCCESS"}}
    commit(SET_BIOMETRIC_VERIFICATION_RESULT, payloadSuccess)
}

const startClaimAuthorization = async ({ commit, state, rootState }) => {
    const OUTPATIENT_CARE_UNIVERSAL_PRODUCT_CODE = '890202'
    const OUTPATIENT_CARE_HUMANO_PRODUCT_CODE = '1086'

    commit(SET_LOADING_CREATE_CLAIM, true)
    const beneficiaryId = state.beneficiarySelected.id || '';
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;
    const sponsorSlug = state.newAuthorization.beneficiarySearch.sponsorSlug;
    const beneficiaryCategory = state.authorizationFormValues.beneficiaryFields.sponsorCategory || null;
    const doctorMedicalLicenseNumber = state.authorizationFormValues.doctorFields.license;
    const doctorCountryCode = state.authorizationFormValues.doctorFields.country;
    const diagnosesRequest = state.authorizationFormValues.doctorFields.diagnoses;

    let productCode = state.authorizationFormValues.doctorFields.productCode;
    if(!productCode){
        switch(sponsorSlug){
            case 'do-universal':
                productCode = OUTPATIENT_CARE_UNIVERSAL_PRODUCT_CODE
                break;

            case 'do-humano':
            case 'do-primera':
                productCode = OUTPATIENT_CARE_HUMANO_PRODUCT_CODE
                break;
        }
    }

    const sponsorParameters = { productCode, beneficiaryCategory }

    const body = {
        beneficiaryId,
        sponsorSlug,
        providerTransactionId: uuidv4(),
        sponsorParameters,
        doctorMedicalLicenseNumber,
        doctorCountryCode
    }

    if(diagnosesRequest != undefined || diagnosesRequest != null) {
        body.diagnoses = diagnosesRequest
    }

    try {
        const response = await arcService.startClaimAuthorization(providerSlug, body)
        if (response.status === 202) {
            const location = response.headers.location
            if (location) {
                const monitor = await arcService.getClaimProcessMonitor(location)
                if (monitor.data.status === 'ERROR') {
                    commit(SET_CREATE_CLAIM_ERROR, monitor.data)
                    throw monitor.data
                }
                const monitorData = camelizeKeys(monitor.data)

                const defaultDiagnosis = {code: 'Z00.0', codingSystem: 'ICD-10'};
                const diagnoses = diagnosesRequest ? diagnosesRequest : [defaultDiagnosis];
 
                const { license: doctorMedicalLicenseNumber, country: doctorCountryCode,
                specialty: doctorSpecialtyName } = state.authorizationFormValues.doctorFields

                const { id: biometricReadingId } = state.biometricVerificationResult

                const doctorName = state.authorizationFormValues.doctorFields.doctorInformation &&
                                    state.authorizationFormValues.doctorFields.doctorInformation.name ||
                                        state.authorizationFormValues.doctorFields.name

                const completeClaimBody = {
                    biometricReadingId, 
                    doctorMedicalLicenseNumber, 
                    doctorCountryCode, 
                    doctorSpecialtyName,
                    doctorName, 
                    diagnoses
                }

                await arcService.completeClaimAuthorization(providerSlug, monitorData.id, completeClaimBody)
                commit(SET_CREATE_CLAIM_RESULT, 'SUCCESS')
                commit(SET_COMPLETED_DISPENSATION, "SUCCESS")
                commit(CLEAR_NEW_AUTHORIZATION)
                router.push('/home')
            }
        }
        commit (SET_LOADING_CREATE_CLAIM, false)
    } catch (error) {
        commit(SET_CREATE_CLAIM_RESULT, 'ERROR')
        commit(SET_COMPLETED_DISPENSATION, "ERROR")
        commit(SET_CREATE_CLAIM_ERROR, error)
        commit(CLEAR_NEW_AUTHORIZATION)
        commit(SET_LOADING_CREATE_CLAIM, false)
        router.push('/home')
    }
}

const setCreateClaimResult = ({commit}, payload) => {
    commit(SET_CREATE_CLAIM_RESULT, payload)
}

const setAuthorizationDetailHeader = ({commit}, payload) => {
    commit(AUTHORIZATION_DETAIL_HEADER, payload)
}

const setAuthorizationDetail = async ({ commit, rootGetters, dispatch }, authorizationId) => {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    commit(AUTHORIZATONS_LOADING, true)
    try {
        const response = await arcService.getAuthorizationDetail(providerSlug, authorizationId);
        const camelizeResponse = camelizeKeys(response.data)
        commit(AUTHORIZATION_DETAIL_SUCCESS, camelizeResponse)
        if(camelizeResponse.transactionType === "OUTPATIENT_CARE"){
            dispatch("setSpecificSponsorProduct")
        }
        commit(AUTHORIZATONS_LOADING, false)
    } catch (error) {
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    }      
}

const setAuthorizationDetailFile = async ({commit, rootGetters}, authorizationFileId) => {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    commit(AUTHORIZATONS_LOADING, true)
    try {
        const response = await arcService.getAuthorizationFile(providerSlug, authorizationFileId);
        commit(AUTHORIZATION_DETAIL_FILE, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    } catch (error) {
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    } 
}

const clearAuthorizationDetail = ({commit}) => {
    commit(CLEAR_AUTHORIZATION_DETAIL)
}

const toggleDialogAuthorizationFilesAttach = ({commit}, payload) => {
    commit(DIALOG_AUTHORIZATION_FILES_ATTACH, payload)
}

const voidAuthorization = async ({ commit, state }, authorizationId) => {
    try{
        const authorizations = state.prescription.authorizations || [{id: authorizationId}]
        for (const authorization of authorizations) {
            const authorizationId = authorization.id;
            await arcService.voidClaimAuthorization(authorizationId)
        }
    }catch(error){
        commit(SET_LOADING_CREATE_CLAIM, false)
    }
}

const cancelClaim = async ({commit, state, rootGetters}, claimId) => {
    try{
        const claimToCancel = state.dispensation.cosharings.id || claimId
        const providerSlug = rootGetters.tokenExtensions.providerSlug 
        if(claimToCancel){
            await arcService.cancelClaim(providerSlug, claimToCancel)
        }
    }catch(error){
        commit(SET_LOADING_CREATE_CLAIM, false)
    }
}

const backStep = ({commit})=> {
  commit(AUTHORIZATION_CREATION_BACK_STEP)
}

const nextStep = ({commit})=> {
  commit(AUTHORIZATION_CREATION_NEXT_STEP)
}

const uploadPrescriptionFile = async ({commit, state}, payload) => {
    commit(SET_LOADING_CREATE_CLAIM, true)
    try{
        const documentCoverageSlug = "PRESCRIPTION_DRUGS";
        const authorizationRequestId = state.prescription.id;
        const authorizations = state.prescription.authorizations;

        for(const authorization of authorizations){
            const authorizationId = authorization.id
            await arcService.uploadAuthorizationFile(payload.file, 
                authorizationRequestId,
                authorizationId,
                documentCoverageSlug,
                payload.documentTypeSlug);
        }        

        commit(SET_LOADING_CREATE_CLAIM, false)
    }catch(error){
        commit(SET_LOADING_CREATE_CLAIM, false)
    }
}

const clearPrescription = ({commit}) => {
    commit(CLEAR_PRESCRIPTION)
}

const setSponsorProducts = async ({commit, state, rootGetters}) => {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const sponsorSlug = state.newAuthorization.beneficiarySearch.sponsorSlug; 
    commit(AUTHORIZATONS_LOADING, true)
    try{
        const response = await medicalCatalogService.getSponsorProducts(providerSlug, sponsorSlug)
        commit(SET_SPONSOR_PRODUCTS, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    }
}

const setSpecificSponsorProduct = async ({commit, state, rootGetters}) => {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const sponsorSlug = state.authorizationDetail.detail.sponsorSlug;
    const productCode = state.authorizationDetail.detail.sponsorProductCode;
    commit(AUTHORIZATONS_LOADING, true)
    try{
        const response = await medicalCatalogService.getSpecificSponsorProduct(providerSlug, sponsorSlug, productCode)
        commit(SET_SPONSOR_PRODUCT_DETAIL, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    }
}

const clearDispensation = ({commit}) => {
  commit(CLEAR_DISPENSATION)
}

const startDispensation = async({commit, rootState}, approvedProducts) => {
  commit(DISPENSING_LOADING, true)
  
  const startDispensationRequest = dispensingService.generateDispensationRequestPayload(rootState, approvedProducts)

  try{
    const response = await dispensingService.startDispensation(startDispensationRequest.authorizationCode, startDispensationRequest.payload)
    commit(SET_DISPENSING_COSHARINGS, camelizeKeys(response.data))
    commit(DISPENSING_LOADING, false);
    commit(DISPENSING_ERROR, {});
  }catch(error){
    commit(DISPENSING_LOADING, false);
    commit(DISPENSING_ERROR, error);
  }
}

const updateDispensation = async({commit, rootState}, updateDispensationRequest) => {
  commit(DISPENSING_LOADING, true)

  const currencyCode = rootState.authorization.beneficiary.currencyCode || ''
  const products = dispensingService.generateApprovedProductsPayload(updateDispensationRequest.approvedProducts);

  let startDispensationPayload = {
    currencyCode,
    products
  }

  try{
    const updateDispensationResponse = await dispensingService.updateDispensation(updateDispensationRequest.dispensingId, startDispensationPayload)
    if (updateDispensationResponse.status === 202) {
      const location = updateDispensationResponse.headers.location;

      if (location) {
        const monitor = await dispensingService.getDispensingMonitor(location);
        if (monitor.data.status === 'ERROR') {
          throw monitor.data
        }
        commit(SET_DISPENSING_COSHARINGS, camelizeKeys(monitor.data))
      }
    }
    commit(DISPENSING_LOADING, false);
    commit(DISPENSING_ERROR, {});
  }catch(error){
    commit(DISPENSING_LOADING, false);
    commit(DISPENSING_ERROR, error);
  }
}

const completeDispensation = async({commit, state}, invoiceFields) => {
  commit(DISPENSATION_CREATION_LOADING, true);
  commit(SET_COMPLETED_DISPENSATION, "")
  commit(SET_CREATE_CLAIM_RESULT, "")

  const dispensingId = state.dispensation.cosharings.id;

  const documentPayload = {
    amount: parseFloat(invoiceFields.invoiceAmount.toString().replace(/,/g, '')),
    documentDate: invoiceFields.invoiceDate,
    documentNumber: invoiceFields.invoiceNumber,
    providerTransactionId: uuidv4()
  }

  try{
    await dispensingService.completeDispensation(dispensingId, documentPayload);
    commit(SET_COMPLETED_DISPENSATION, "SUCCESS")
    commit(SET_CREATE_CLAIM_RESULT, 'SUCCESS')
    commit(DISPENSATION_CREATION_LOADING, false);
    commit(DISPENSING_ERROR, {});
    router.push('/home')
  }catch(error){
    commit(SET_COMPLETED_DISPENSATION, "ERROR")
    commit(SET_CREATE_CLAIM_RESULT, 'ERROR')
    commit(DISPENSATION_CREATION_LOADING, false);
    commit(DISPENSING_ERROR, error);
    router.push('/home')
  }
}

const setDispensationResult = ({ commit }, payload) => {
  commit(SET_COMPLETED_DISPENSATION, payload)
}

const setSponsors = async ({ commit, rootGetters }) => {
    commit(AUTHORIZATONS_LOADING, true)
    try{
        const providerSlug = rootGetters.tokenExtensions.providerSlug
        const response = await providerService.getSponsors(providerSlug);
        commit(SET_SPONSORS, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATIONS_ERROR, error)
        commit(AUTHORIZATONS_LOADING, false)
    }
    
}

const setProviderProductTypes = async ({commit, rootGetters}) => {
    commit(AUTHORIZATONS_LOADING, true)
    try{
        const providerBranchId = rootGetters.tokenExtensions.providerBranchId
        const response = await arcService.getProviderProductTypes(providerBranchId)
        const camelizeResponse = camelizeKeys(response.data);
        const sanitizeData = camelizeResponse.map(type => { return type.productType});
        commit(SET_PROVIDER_PRODUCT_TYPES, sanitizeData)
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATONS_LOADING, false)
        commit(AUTHORIZATIONS_ERROR, error)
    }
}

const setBiometricVerificationRequired = ({ commit }, payload) => {
    commit(SET_BIOMETRIC_VERIFICATION_REQUIRED, payload)
}


const startAuthorizationClaim = async ({commit, state, dispatch, rootGetters}) => {
    commit(SET_LOADING_CREATE_CLAIM, true)
    commit(PRESCRIPTION_CREATED, false)

    const authorizationRequestPayload = arcService.createAuthorizationRequestPayload(state, rootGetters)
    const authorizationFiles = state.authorizationFormValues.doctorFields.receiptFile;
    const authorizationTransactionType = state.newAuthorization.type.transactionType;
    
    try{
        const response = await arcService.createAuthorizationRequest(authorizationRequestPayload, 
                                                                     authorizationTransactionType, 
                                                                     authorizationFiles);
        commit(SET_PRESCRIPTION, response);
        commit(PRESCRIPTION_CREATED, true)
        commit(SET_CREATE_CLAIM_RESULT, 'SUCCESS')
        commit(SET_LOADING_CREATE_CLAIM, false)
        dispatch("nextStep")
    }catch(error){
        commit(SET_CREATE_CLAIM_RESULT, 'ERROR')
        commit(SET_CREATE_CLAIM_ERROR, error)
        commit(SET_LOADING_CREATE_CLAIM, false)
    }
}

const startAuthorizationClaimAndDispensation = async ({commit, state, rootState, rootGetters, dispatch}) => {
    commit(SET_LOADING_CREATE_CLAIM, true)
    commit(PRESCRIPTION_CREATED, false)

    const authorizationRequestPayload = arcService.createAuthorizationRequestPayload(state, rootGetters)
    const authorizationTransactionType = state.newAuthorization.type.transactionType;
    const doctorFields = state.authorizationFormValues.doctorFields
    const authorizationFiles = getAuthorizationFiles(authorizationTransactionType, doctorFields)

    try{
        const response = await arcService.createAuthorizationRequest(authorizationRequestPayload, 
                                                                     authorizationTransactionType, 
                                                                     authorizationFiles);
        commit(SET_PRESCRIPTION, response);
        commit(PRESCRIPTION_CREATED, true);
        commit(SET_CREATE_CLAIM_RESULT, 'SUCCESS');

        if(response.authorizations.length > 0){
            const authorizations = response.authorizations
            let approvedProducts = []
            for(const authorization of authorizations){
                if(authorization.products.length > 0){
                    const authorizationProducts = authorization.products
                    authorizationProducts
                        .filter(product => product.status === 'APPROVED')
                        .map(product => ({...product, subtotal: "1.00"}))
                        .map(product => approvedProducts.push(product))
                }
            }

            if(approvedProducts.length > 0){
                const dispensingRequest = dispensingService.generateDispensationRequestPayload(rootState, approvedProducts)
                const authorizationCode = dispensingRequest.authorizationCode
                const startDispensationPayload = dispensingRequest.payload

                const response = await dispensingService.startDispensation(authorizationCode, startDispensationPayload)
                commit(SET_DISPENSING_COSHARINGS, camelizeKeys(response.data))
                commit(SET_LOADING_CREATE_CLAIM, false)
                dispatch("nextStep")
            }else{
                let rejectedProductsReasons = []
                for(const authorization of authorizations){
                    if(authorization.products.length > 0){
                        const authorizationProducts = authorization.products
                        authorizationProducts.map(product => rejectedProductsReasons.push({
                            message: product.productName +" "+ product.reason
                        }))
                    }
                }
                throw { 
                    message: vuei18n.t("errors.dispensingRequest.emptyApprovedProducts"),
                    errors: rejectedProductsReasons
                }
            }
        }else{
            throw { message: vuei18n.t("errors.authorizationRequest.emptyAuthorization") }
        }
    }catch(error){
        commit(SET_CREATE_CLAIM_RESULT, 'ERROR')
        commit(SET_CREATE_CLAIM_ERROR, error)
        commit(SET_LOADING_CREATE_CLAIM, false)
    }

}

const startAuthorizationCreationProcess = ({ state, dispatch }) =>{
    const featureToFind = 'AUTOMATIC_DISPENSATION'
    const selectedSponsor = state.newAuthorization.beneficiarySearch.sponsorSlug;
    const sponsorHasAutomaticDispensation = arcService.findSponsorFeature(featureToFind, selectedSponsor);
    
    if(sponsorHasAutomaticDispensation){
        dispatch('startAuthorizationClaimAndDispensation')
    }else{
        dispatch('startAuthorizationClaim')
    }
}

const resetBiometricValidation = ({commit}) => {
    commit(RESET_BIOMETRIC_VALIDATION)
}

const getAuthorizationFiles = (transactionType, fields) => {
    let files = []
    if(transactionType === 'MEDICAL_PROCEDURES' || transactionType === 'DIAGNOSTIC_TESTS'){
        Object.keys(fields).forEach(fileKey => {
            if (fields[fileKey]) {
                if(fields[fileKey].file){
                    const authorizaitonFiles = fields[fileKey].file
                    for (const indexFile in authorizaitonFiles) {
                        files.push({
                            slug: fields[fileKey].slug,
                            file: authorizaitonFiles[indexFile]
                        })
                    }
                }
            }
        })
    }else{
        return files.push(fields.receiptFile[0])
    }

    return files
}

const getSponsorDocumentPolicy = async ({commit, rootState, state}, payload) => {
    commit(AUTHORIZATONS_LOADING, true)
    
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;
    const sponsorSlug = state.newAuthorization.beneficiarySearch.sponsorSlug || payload.sponsor;
    const authorizationType = state.newAuthorization.type
    const transactionType = authorizationType.transactionType || payload.products;
    let productType = authorizationType.productType;

    if(transactionType === 'MEDICAL_PROCEDURES'){
        productType = 'MEDICAL_PROCEDURE'
    }

    if(transactionType === 'DIAGNOSTIC_TESTS' && productType === 'laboratory'){
        productType = 'LABORATORY'
    }

    if(transactionType === 'DIAGNOSTIC_TESTS' && productType === 'diagnostic-test'){
        productType = 'DIAGNOSTIC_TESTS'
    }

    try{
        const response = await arcService.getSponsorDocumentPolicy(providerSlug, sponsorSlug, productType);
        commit(SET_SPONSOR_DOCUMENT_POLICY, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATONS_LOADING, false)
        commit(AUTHORIZATIONS_ERROR, error)
    }
}

const getAuthorizationDocumentPolicy = async ({ commit }, payload) => {
    commit(AUTHORIZATONS_LOADING, true)
    const authorizationId = payload.authorizationId
    try{
        const response = await arcService.getAuthorizationDocumentPolicy(authorizationId);
        commit(SET_SPONSOR_DOCUMENT_POLICY, camelizeKeys(response.data))
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATONS_LOADING, false)
        commit(AUTHORIZATIONS_ERROR, error)
    }
}

const uploadAuthorizationFile = async({commit, dispatch}, payload) => {
    commit(AUTHORIZATONS_LOADING, true)

    const authorizationFile = payload.file;
    const authorizationFileId = payload.authorizationFileId;
    const authorizationFileIdExists = ('authorizationFileId' in payload)
    const authorizationRequestId = payload.authorizationRequestId;
    const authorizationId = payload.authorizationId;
    const documentCoverageSlug = payload.documentCoverageSlug;
    const documentTypeSlug = payload.documentTypeSlug;
    const providerProductCode = payload.providerProductCode || null;
    const productType = payload.productType || null;
    
    try{
        if (authorizationFileIdExists) {
            await arcService.uploadAuthorizationRequestFile(authorizationFile, authorizationRequestId,
                authorizationId, documentCoverageSlug, documentTypeSlug, providerProductCode, productType, authorizationFileId)
        } else {
            await arcService.uploadAuthorizationFile(authorizationFile, authorizationRequestId,
                authorizationId, documentCoverageSlug, documentTypeSlug, providerProductCode, productType)
        }
        commit(AUTHORIZATONS_LOADING, false)
        dispatch('general/configureAlert', {
            active: true,
            type: 'success',
            message: 'Se adjunto el archivo correctamente '
        }, {root: true})
    } catch (error) {
        dispatch('general/configureAlert', {
            active: true,
            type: 'error',
            message: sanitizeEndpointError(error)
        }, { root: true })
        commit(AUTHORIZATONS_LOADING, false)
        commit(AUTHORIZATIONS_ERROR, error)
    }
}

const deleteAuthorizationFile = async({commit, dispatch}, payload) => {
    commit(AUTHORIZATONS_LOADING, true)
    try{
        await arcService.deleteAuthorizationFile(payload)
        commit(AUTHORIZATONS_LOADING, false)
        dispatch('general/configureAlert', {
            active: true,
            type: 'success',
            message: 'Se eliminó correctamente '
        }, {root: true})
    } catch (error) {
        dispatch('general/configureAlert', {
            active: true,
            type: 'error',
            message: sanitizeEndpointError(error)
        }, { root: true })
        commit(AUTHORIZATONS_LOADING, false)
        commit(AUTHORIZATIONS_ERROR, error)
    }
}

const getProvider = async ({commit, rootState}) => {
    commit(AUTHORIZATONS_LOADING, true)
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;

    try{
        const response = await providerService.getProvider(providerSlug);
        const camelizedResponse = response.data.content[0];
        commit(SET_PROVIDER_INFORMATION, camelizeKeys(camelizedResponse))
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        commit(AUTHORIZATONS_LOADING, false)
        commit(AUTHORIZATIONS_ERROR, error)
    }
}

const cancelClaimWithResponse = async ({commit, state, rootGetters, dispatch}, claimId) => {
    const RETRIEVE_RESPONSE = true;

    commit(AUTHORIZATONS_LOADING, true)
    try{
        const claimToCancel = state.dispensation.cosharings.id || claimId
        const providerSlug = rootGetters.tokenExtensions.providerSlug 
        if(claimToCancel){
            await arcService.cancelClaim(providerSlug, claimToCancel, RETRIEVE_RESPONSE)            
            dispatch('general/configureAlert', {
                active: true,
                type: 'success',
                message: vuei18n.t("errors.voidAuthorizations.success")
            }, { root: true })            
        }
        commit(AUTHORIZATONS_LOADING, false)
    }catch(error){
        if(error.response){
            if(error.response.status === 404){
                dispatch('general/configureAlert', {
                    active: true,
                    type: 'success',
                    message: vuei18n.t("errors.voidAuthorizations.success")
                }, { root: true })       
            }else{
                dispatch('general/configureAlert', {
                    active: true,
                    type: 'error',
                    message: sanitizeEndpointError(error)
                }, { root: true })
            }
        }

        commit(AUTHORIZATONS_LOADING, false)
    }
}

const voidAuthorizationWithResponse = async ({ commit, dispatch }, authorizationId) => {
    commit(AUTHORIZATONS_LOADING, true)
    try{
        await arcService.voidClaimAuthorization(authorizationId)
    }catch(error){
        dispatch('general/configureAlert', {
            active: true,
            type: 'error',
            message: sanitizeEndpointError(error)
        }, { root: true })
        commit(SET_LOADING_CREATE_CLAIM, false)
        commit(AUTHORIZATONS_LOADING, false)
    }
}

const setBiometricVerificationMethod = async ({commit}, payload) => {
    commit(SET_BIOMETRIC_VERIFICATION_METHOD, payload)
}

const captureFingerPrint = async ({ commit }) => {
    commit(SET_LOADING_VERIFICATION, true)
  
    try {
      const response = await fingerPrintService.getFingerPrintValidation()
      commit(SET_LOADING_VERIFICATION, false)
      return response
    } catch (error) {
      commit(SET_BIOMETRIC_VERIFICATION_RESULT, { verificationStatus: 'ERROR' })
      commit(SET_LOADING_VERIFICATION, false)
      throw error
    }
  }

  const returnToInitialValuesBiometricValidation = ({commit}) => {
    commit(SET_BIOMETRIC_VERIFICATION_RESULT, null)
    commit (SET_LOADING_VERIFICATION, false)
  }

const getSponsorTransactionCoverageTypeRequirements = async ({commit, rootState}, payload) => {
    const providerSlug = rootState.auth.tokenExtensions.providerSlug;
    const sponsorSlug = rootState.authorization.newAuthorization.beneficiarySearch.sponsorSlug;
    
    try {
        const response =  await providerService.getSponsorTransactionCoverageTypeRequirements(providerSlug, sponsorSlug, payload);
        const data = camelizeKeys(response.data)
        commit(SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS, camelizeKeys(data))
        commit(SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR)
    } catch (error) {
        commit(SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS_ERROR, error)
        commit(SPONSOR_TRANSACTION_COVERAGE_TYPE_REQUIREMENTS)
        throw error
    }
}

export default {
    setAuthorizationType,
    setAuthorizationSponsor,
    getSponsorForm,
    setSponsorSearchMethod,
    setInputSponsorSearchValues,
    getBeneficiaries,
    getAuthorizations,
    setBeneficiarySuccess,
    setBeneficiarySelected,
    setBeneficiarySelection,
    completeAuthorizationTypeStep,
    completeSponsorStep,
    completeMethodStep,
    completeBeneficiaryStep,
    cleanNewAuthorizationSteps,
    completeBeneficiarySearch,
    getBeneficiary,
    setAuthorizationFormValues,
    verifyBiometric,
    startClaimAuthorization,
    setNavBarType,
    cancelNewAuthorization,
    setCreateClaimResult,
    setAuthorizationDetail,
    setAuthorizationDetailHeader,
    clearAuthorizationDetail,
    toggleDialogAuthorizationFilesAttach,
    setAuthorizationDetailFile,
    startAuthorizationClaim,
    backStep,
    nextStep,
    uploadPrescriptionFile,
    clearPrescription,
    voidAuthorization,
    setSponsorProducts,
    setSpecificSponsorProduct,
    startDispensation,
    updateDispensation,
    completeDispensation,
    setDispensationResult,
    clearDispensation,
    setSponsors,
    setProviderProductTypes,
    setBiometricVerificationRequired,
    biometricValidationBypass,
    startAuthorizationCreationProcess,
    startAuthorizationClaimAndDispensation,
    cancelClaim,
    resetBiometricValidation,
    getSponsorDocumentPolicy,
    uploadAuthorizationFile,
    deleteAuthorizationFile,
    getProvider,
    getAuthorizationDocumentPolicy,
    cancelClaimWithResponse,
    voidAuthorizationWithResponse,
    setBiometricVerificationMethod,
    captureFingerPrint,
    returnToInitialValuesBiometricValidation,
    getSponsorConfiguration,
    updateBeneficiary,
    getSponsorTransactionCoverageTypeRequirements
}